export enum MeetingStatus {
    Scheduled = "scheduled",
    Voting = "voting",
    Completed = "completed",
    Cancelled = "cancelled",
}

export enum MeetingType {
    Remote = "remote",
    InPerson = "in_person",
    Hybrid = "hybrid",
}

export enum AttendeeRsvp {
    Pending = "pending",
    Accepted = "accepted",
    Declined = "declined",
}
